export default function Serve() {
    // const appUrl = 'http://127.0.0.1:8000/api/v1/';
    const appUrl = 'https://genoma-server.azurewebsites.net/api/v1/';
    // const appUrl = 'https://safebox-server-homologacao.azurewebsites.net/api/v1/';
    return appUrl;
}